import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import PolicyDetailsPage from 'ent-capability-quoteandbind-common-react/pages/PolicyDetails/PolicyDetailsPage.jsx';
import TWIAPaymentDetailsPage from 'twia-capability-quoteandbind-residential-react/pages/PaymentDetails/PaymentDetailsPage.jsx';
import TWIAQuoteCPQualificationPage from './pages/Qualification/QualificationPage.jsx';
import BuildingsAndLocationsPage from './pages/BuildingsAndLocations/BuildingsAndLocationsPage.jsx';
import QuotePage from './pages/Quote/QuotePage.jsx';
import AdditionalInformationPage from './pages/AdditionalInformation/AdditionalInformationPage.jsx';
import CoverageSummaryPage from './pages/CoverageSummary/CoverageSummaryPage.jsx';




setComponentMapOverrides(
    {
        TWIAQuoteCPQualificationPage: { component: 'TWIAQuoteCPQualificationPage' },
        TWIAQuoteCPPolicyDetailsPage: { component: 'TWIAQuoteCPPolicyDetailsPage' },
        TWIAQuoteCPBuildingsAndLocationsPage: { component: 'TWIAQuoteCPBuildingsAndLocationsPage' },
        TWIAQuoteCPQuotePage: { component: 'TWIAQuoteCPQuotePage' },
        TWIAQuoteCPAdditionalInformationPage: { component: 'TWIAQuoteCPAdditionalInformationPage' },
        TWIAQuoteCPCoverageSummaryPage: { component: 'TWIAQuoteCPCoverageSummaryPage' },
        TWIAQuoteCPPaymentDetailsPage: { component: 'TWIAQuoteCPPaymentDetailsPage' }

    },
    {
        TWIAQuoteCPQualificationPage,
        TWIAQuoteCPPolicyDetailsPage: PolicyDetailsPage,
        TWIAQuoteCPBuildingsAndLocationsPage: BuildingsAndLocationsPage,
        TWIAQuoteCPQuotePage: QuotePage,
        TWIAQuoteCPAdditionalInformationPage: AdditionalInformationPage,
        TWIAQuoteCPCoverageSummaryPage: CoverageSummaryPage,
        TWIAQuoteCPPaymentDetailsPage: TWIAPaymentDetailsPage
    }
)

export { default as TWIACommercialWizard } from './TWIACommercialWizard.jsx';
